import React from 'react';
import { Service } from '../../../../../redux/services/types';
import { DangerButton } from '../../../../../healtheraComponents';
import { useNotifyOnDeletion } from './hooks/useNotifyOnDeletion';
import { useRedirectAfterDeletion } from './hooks/useRedirectAfterDeletion';
import { useDeleteWithConfirmation } from './hooks/useDeleteWithConfirmation';

interface Props {
  service: Service;
}

const DeleteButton = ({ service }: Props) => {
  const { deleteWithConfirmation, isSuccess } = useDeleteWithConfirmation(service);

  useNotifyOnDeletion(isSuccess);
  useRedirectAfterDeletion(service, isSuccess);

  return <DangerButton onClick={deleteWithConfirmation}>Delete</DangerButton>;
};

export default DeleteButton;
